import { alpha, mix, mixWhite } from '@wojtekmaj/color-utils';

const brandColors = {
  orange: '#f79938',
};

const colors = {
  'active-menu-item': brandColors.orange,
  accent: brandColors.orange,
  background: '#f7f5f0',
  'background-2': '#ede8e3',
  'card-background': '#f7f5f0',
  'dialog-background': '#f7f5f0',
  link: '#362b26',
  marine: '#63e9e0',
  'menu-background': '#362b26',
  orange: '#eb5341',
  'orange-light': '#fbc288',
  overlay: alpha(brandColors.orange, 0.2),
  'overlay-fallback': mixWhite(brandColors.orange, 0.2),
  'primary-button-background': brandColors.orange,
  'primary-button-disabled-background': '#b8b0a1',
  'primary-button-disabled-text': mix('#362b26', '#b8b0a1', 0.7),
  'primary-button-focus-background': mix(brandColors.orange, '#362B26', 0.8),
  'primary-button-focus-text': '#362b26',
  'primary-button-hover-background': mixWhite(brandColors.orange, 0.8),
  'primary-button-hover-text': '#362b26',
  'primary-button-text': '#362b26',
  'secondary-button-background': '#efb086',
  'secondary-button-disabled-background': '#b8b0a1',
  'secondary-button-disabled-text': mix('#362b26', '#b8b0a1', 0.7),
  'secondary-button-focus-background': mix('#efb086', '#362b26', 0.8),
  'secondary-button-focus-text': '#362b26',
  'secondary-button-border-color': '#00000000',
  'secondary-button-hover-background': mixWhite('#efb086', 0.8),
  'secondary-button-hover-text': '#362b26',
  'secondary-button-text': '#362b26',
  supplemental: '#fbc288',
  text: '#362b26',
  'text-light': alpha('#362b26', 0.75),
  'text-muted': alpha('#362b26', 0.25),
  'toggle-background': '#b8b0a1',
  'toggle-active-background': brandColors.orange,

  beige: '#fde7cf',
  'beige-dark': '#fcd1a6',
  'beige-light': '#fff9f3',

  /** @deprecated */
  primary: '#f79938',
  /** @deprecated */
  'primary-dark': '#b82e36',
  /** @deprecated */
  'primary-light': alpha('#f79938', 0.1),
  /** @deprecated */
  secondary: '#a16b46',
  /** @deprecated */
  'secondary-dark': '#805437',
  /** @deprecated */
  'secondary-light': alpha('#a16b46', 0.1),
  /** @deprecated */
  'text-on-white': '#362b26',
  /** @deprecated */
  'text-on-white-light': alpha('#362b26', 0.75),
  /** @deprecated */
  'text-on-white-muted': alpha('#362b26', 0.25),

  /* Inherited colors */
  /** @deprecated */
  black: '#362b26',
  /** @deprecated */
  'error-dark': '#c50606',
  /** @deprecated */
  'error-light': '#ff746b',
  /** @deprecated */
  'error-background': alpha('#ff2323', 0.1),
  /** @deprecated */
  gray: '#c9d9e8',
  /** @deprecated */
  'gray-light': '#f2f6f8',
  /** @deprecated */
  'info-dark': '#026f9c',
  /** @deprecated */
  'info-light': '#2ec1ff',
  /** @deprecated */
  'info-background': alpha('#00b4ff', 0.1),
  /** @deprecated */
  'success-dark': '#106d1f',
  /** @deprecated */
  'success-light': '#74d884',
  /** @deprecated */
  'success-background': alpha('#2aac3f', 0.1),
  /** @deprecated */
  'warning-dark': '#85722f',
  /** @deprecated */
  'warning-light': '#ffdd66',
  /** @deprecated */
  'warning-background': alpha('#ffdd66', 0.15),
  /** @deprecated */
  white: '#ffffff',
} as const;

export default colors;
